import { useRouter } from '$actions/useRouter'
import { useRouteSummary } from '$contexts/Router'

/**
 * Redirect info to whatever current URL's `return_to` query parameter.
 */
export const useReturnToInfo = () => {
  const { queryParams } = useRouter()
  const { details } = useRouteSummary()

  const { return_to } = { ...queryParams }

  const isValid = (() => {
    if (!return_to) return false

    return Object.keys(details).includes(return_to)
  })()

  return {
    isValid,
    return_to
  }
}

export default useReturnToInfo
